module.exports = __webpack_public_path__ + "static/media/facebook.38593a22.svg";